import { render, staticRenderFns } from "./behind_ear_s.vue?vue&type=template&id=333a019c"
import script from "./behind_ear_s.vue?vue&type=script&lang=js"
export * from "./behind_ear_s.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports